import React from 'react';
import { Typography } from '@material-ui/core';

import { Feedback } from './feedback';

interface Props {
  message: string;
  style?: React.CSSProperties;
}

export const WarningDisplay: React.FC<Props> = ({ message, style }) => (
  <Feedback show severity="warning" style={style}>
    <Typography variant="body1">{message}</Typography>
  </Feedback>
);
